import * as Sentry from '@sentry/nextjs'
import axios from 'axios'
import { RedirectRequestParams, RedirectRequestResponse } from '../types'

async function redirectToBooking(
	params: RedirectRequestParams
): Promise<RedirectRequestResponse | null> {
	try {
		const res = await axios.postForm<RedirectRequestResponse>(
			process.env.NEXT_PUBLIC_BACKEND_URL + '/hotels/hotels-redirect',
			{ ...params },
			{ withCredentials: true }
		)
		return res.data
	} catch (error) {
		Sentry.setContext('Request Params', {
			searchParams: JSON.stringify(params),
		})
		console.log('Error in hotels-redirect:', error)
		Sentry.captureException(error)
		return null
	}
}

export default redirectToBooking
